import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";
import React from 'react'

const WarningModal = (props) => {
    const { handleClose, handleOk, open } = props;

    return (
        <Dialog
            fullWidth
            maxWidth={"sm"}
            open={open}
            onClose={() => {
                handleClose();
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <DialogTitle style={{ backgroundColor: '#007BEF', color: 'white' }} >{props.title}</DialogTitle>
            <DialogContent style={{ margin: "auto" }}>
                <Typography>{props.message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    Cancel
                </Button>
                <Button onClick={handleOk}>Yes</Button>
            </DialogActions>
        </Dialog>)
}

export default WarningModal